export default __webpack_public_path__ + "static/media/DDS207.711c9abc.png";